"use client";

import { ld } from "@/lib/theme/light-dark";
import { useTranslations } from "next-intl";
import Link from "next/link";
import type { ReactNode } from "react";

import { H } from "../hero-tokens";
import { DefeatedToolsStage } from "./defeated-tools-stage";
import "./defeated-tools.css";

/** Off until the concept is reworked (29.10.2026); code stays, flip to show it again. */
export const DEFEATED_TOOLS_VISIBLE = false;

/** "Ersetze deine gesamte Softwarelandschaft." — shared by desktop and mobile; the stage scales itself. */
export function DefeatedToolsSection(props: {
  /** Phone: smaller headline. */
  readonly compact: boolean;
}): ReactNode {
  const t = useTranslations("marketing.defeatedTools");
  return (
    <section
      aria-labelledby="defeated-tools-heading"
      style={{
        maxWidth: 1240,
        margin: "clamp(96px, 10vw, 140px) auto 0",
        padding: "0 clamp(16px, 4vw, 28px)",
      }}
    >
      <div style={{ textAlign: "center", maxWidth: 1100, margin: "0 auto" }}>
        <h2
          id="defeated-tools-heading"
          style={{
            margin: 0,
            fontFamily: H.display,
            fontWeight: 400,
            fontSize: props.compact ? 34 : "clamp(2rem, 4vw, 3.25rem)",
            lineHeight: props.compact ? 1.12 : 1.08,
            letterSpacing: "-0.018em",
            textWrap: "balance",
            color: ld("#0B0F19", "#fafafa"),
          }}
        >
          {t("headline")}
        </h2>
        <p
          style={{
            margin: "16px auto 0",
            fontSize: "clamp(1rem, 1.3vw, 1.125rem)",
            lineHeight: 1.55,
            color: ld("rgba(11,15,25,0.6)", "rgba(250,250,250,0.6)"),
          }}
        >
          {t.rich("sub", {
            link: (chunks): ReactNode => (
              <Link
                // i18n-exempt: route path with anchor, not copy
                href="/preise#spar-rechner"
                className="mkdt-calc-link"
                style={{ color: ld("#0B0F19", "#fafafa"), borderBottom: `2px solid ${H.ctaGreen}` }}
              >
                {chunks}
              </Link>
            ),
          })}
        </p>
      </div>
      <div style={{ marginTop: "clamp(20px, 3vw, 40px)" }}>
        <DefeatedToolsStage />
      </div>
    </section>
  );
}
